import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialProjectItemImportState: Dtos.ProjectItemImport & IRegistrationFormState = {
    id: null,
    projectId: null,
    project: null,
    templateCategories: null,
    active: null,
    display: null,
    selectedItems: [],
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface IProjectItemImportReduxFormState {
    id: IFieldState<number>,
    projectId: IFieldState<number>,
    project: IFieldState<Dtos.Project>,
    display: IFieldState<string>,
    active: IFieldState<boolean>,
    selectedItems: IFieldState<number[]>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>
}
